import { useEffect, useCallback, useState } from "react";
import 'styles/quotestaff.css';
import api from "api";

const QuoteStaffLine = (
    {
        line,
        setReload,
        lastNum,
        quoteid
    }
) => {

    const [ value, setValue ] = useState("");
    const [ price, setPrice ] = useState("");
    const [ newOne, setNewOne ] = useState(true);

    useEffect(()=>{
        if (line) {
            setValue(line.desc);
            setPrice(parseFloat(line.price));
            setNewOne(false);
        }
    },[line]);
    
    const handleChange = (e) => {
        setValue(e.target.value);        
    };
    
    const handleChangePrice = (e) => {
        const value = e.target.value;
        const regex = /^\d*(\.\d{0,2})?$/;
        if (value === "") setPrice("");
        else if (regex.test(value)) setPrice(value)
    }

    const handleUp = () => {
        api.post(`staff/up/${line.id}`)
        .then(()=>{ setReload(true); });
    };
    
    const handleDown = () => {
        api.post(`staff/down/${line.id}`)
        .then(()=>{ setReload(true); });
    };

    const handleBlur = () => {
        if (value !=="" && parseFloat(price)>0)
            if (newOne)
                api.post(`staff/create`, {  
                    price : parseFloat(price),
                    desc : value,
                    num : lastNum+1,
                    quote : quoteid
                })
                .then(()=>{ 
                    setReload(true);
                    setNewOne(true);
                    setPrice("");
                    setValue("");
                }); 
            else 
                api.put(`staff/update/${line.id}`, {
                    price : parseFloat(price),
                    desc : value,
                    quote : quoteid,
                    num : line.num
                })
                .then(()=>{ setReload(true); }); 
    }   

    const handleDelete = () => {
        api.delete(`staff/del/${line.id}`)
        .then(()=>{ setReload(true); });
    }
    
    return (
        <div
            className="QuoteStaffLine"
        >
            <input
                type="text"
                onChange={handleChange}
                value={value}
                list="items"
                onBlur={handleBlur}
            />
            <input
                type="text"
                onChange={handleChangePrice}
                value={price}
                onBlur={handleBlur}
            />
            {
                line
                &&
                line.num > 1
                ?
                    <span
                        onClick={handleUp}
                        className="QuoteStaffIcon"
                    >
                        ▲
                    </span>
                :
                    <span></span>
            }
            {
                line
                &&
                line.num < lastNum
                ?
                    <span
                        className="QuoteStaffIcon"
                        onClick={handleDown}
                    >
                        ▼
                    </span>
                :
                    <span></span>
            }
            {
                line
                ?
                    <span
                        className="QuoteStaffIcon"
                        onClick={handleDelete}
                    >
                        🗑️
                    </span>
                :
                    <span></span>
            }
        </div>
    );
};


const QuoteStaff = (
    {
        setStaff,
        selectedQuote,
    }
) => {

    const [ values, setValues ] = useState([]);
    const [ reload, setReload ] = useState(true);
    const [ lastNum, setLastNum ] = useState();
 
    // fonction pour traiter la touche ECHAP
    const handleKey = useCallback((e) => {
        if (e.key === 'Escape') {
            setStaff(false);
        }
        if (e.key === 'Enter') {
            document.body.setAttribute('tabindex', '-1');
            document.body.focus();
            document.body.removeAttribute('tabindex');
        }
    }, [setStaff]);

    // fonction pour intercepter le clavier
    useEffect(() => {
        document.addEventListener('keydown',handleKey);
        return () => { 
            document.removeEventListener('keydown',handleKey);
        }
    },[handleKey]);

    // récupère les données
    useEffect(()=>{
        if (selectedQuote && reload) {
            api.get(`staff/${selectedQuote.id}/get`)
            .then((response)=>{
                setLastNum(response.data.length);
                setValues(response.data);
                setReload(false);
            });
        }
    },[selectedQuote, reload]);
    

    const lines = [
        "heures technicien",
        "heures régisseur son",
        "heures régisseur lumière",
        "journée technicien",
        "journée régisseur son",
        "journée régisseur lumière",
    ]

    return (
            selectedQuote
            &&
            <div
                id="QuoteStaff"
            >
                <h1>DEVIS {selectedQuote.id}</h1>
                <h2>{selectedQuote.event}</h2>   
                <h3>Équipe technique</h3>
                <div
                    id="QuoteStaffBlock"
                >
                    {
                        values.length > 0
                        &&
                        values.map((value)=>(<QuoteStaffLine
                            key={value.id}
                            line={value}
                            setReload={setReload}
                            lastNum={lastNum}
                            quoteid={selectedQuote.id}
                        />))
                    }
                    <QuoteStaffLine
                        list={null}
                        setReload={setReload}
                        lastNum={lastNum}
                        quoteid={selectedQuote.id}
                    />
                    {   
                        <datalist id="items">
                            {lines.map((line) => (
                                <option key={line} value={line}/>
                            ))}
                        </datalist>
                    }
                </div>
            </div>
    );
};

export default QuoteStaff;